import React, { useEffect, useState } from "react";
import Parse from "parse";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, Button, Checkbox, ListItemText, OutlinedInput, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedQuotationType } from "../features/cart/cartSlice";
import { tokens } from "../theme";
import AddQuotationTypeModal from "./AddNewQuotationTypeModal";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SelectQuotationType = (props) => {
  const selectedQuotationType = useSelector((state) => state.cart.quotationType);
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const quotationTypes = useSelector((state) => state.cart.quotationTypes);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
  }, [quotationTypes]);

  const formatSelectedValues = (selected) => {
    return selected
      .filter(Boolean)  // Remove falsy values (undefined, null, empty strings)
      .filter(item => item.trim())  // Remove whitespace-only strings
      .join(', ');
  };

  return (
    <>
    <FormControl style={{ width: '100%' }} className="text-center">
      <InputLabel id="demo-simple-select-label">Type</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        multiple
        value={selectedQuotationType}
        label="Finish"
        onChange={(event) => dispatch(setSelectedQuotationType(event.target.value))}
        input={<OutlinedInput label="Tag" />}
        renderValue={(selected) => formatSelectedValues(selected)}
        MenuProps={MenuProps}
        sx={{ width: 300 }}
      >
        <MenuItem sx={{width: '100%'}}>
          <Box display='flex' justifyContent={'space-between'} width={'100%'} alignItems={'center'} mt={1} pb={1} borderBottom={'1px solid gray'}>
            <Typography sx={{
                      color: colors.greenAccent[600]}}>
              Quick Actions
            </Typography>
              <Button
                sx={{
                  backgroundColor: colors.greenAccent[700],
                  color: colors.grey[100],
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "5px 10px",
                }}
                onClick={() => setOpenModal(true)}
                >Add New</Button>
          </Box>
        </MenuItem>
        {quotationTypes.map((type, index) =>
          <MenuItem key={index} value={type}>
            <Checkbox checked={selectedQuotationType?.indexOf(type) > -1} />
            <ListItemText primary={type} />
          </MenuItem>)
        }
      </Select>
    </FormControl>
    <AddQuotationTypeModal
      open={openModal}
      handleClose={() => setOpenModal(false)}
    />
    </>
  );
};

export default SelectQuotationType;
